/* eslint-disable no-undef */
/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import Chart from 'common/chartjs/register';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class ServiceRecoveryFunnel extends Component {
  constructor(props) {
    super(props);
    this.drawLabelsAboveBars = this.drawLabelsAboveBars.bind(this);
  }

  options(animationOnCompleteFunction, datasetsWithPercentageIntervals) {
    return {
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
      scales: {
        y: {
          ticks: {
            suggestedMax: this.props.data.chart_max,
            beginAtZero: true,
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        x: {
          ticks: {
            maxRotation: 0,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
      },
      animation: {
        duration: 1,
        onComplete: animation => {
          animationOnCompleteFunction(animation, datasetsWithPercentageIntervals);
        },
      },
      transitions: {
        active: {
          animation: {
            duration: 0,
          },
        },
      },
    };
  }

  // It isn't recommended to modify this function any further
  // It gets a ChartJS canvas and draws directly on it, applying labels to bar charts in non-standard locations
  //
  // Further changes to this view in general should probably prompt a rewrite
  drawLabelsAboveBars(animation, datasets) {
    let chartInstance = animation.chart;
    let ctx = chartInstance.ctx;
    const fontFamily = 'Nunito';
    const fontSize = Chart.defaults.font.size || 14;
    const fontStyle = Chart.defaults.font.style || 'normal';

    ctx.font = `${fontStyle} ${fontSize}px ${Chart.defaults.font.family}`;

    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    datasets.forEach((dataset, i) => {
      var meta = chartInstance.getDatasetMeta(i);
      meta.data.forEach((bar, index) => {
        const data = dataset.data[index];
        ctx.font = `bold 12pt ${fontFamily}`;
        ctx.fillStyle = '#000000';
        const offsetHeight = index % 2 == 1 ? 25 : 5;
        ctx.fillText(data, bar.x, bar.y - offsetHeight);
      });
    });
  }

  // Provides blank labels for the graph's X axis below the percentage indicators
  labelsWithPercentageIntervals() {
    return this.props.data.columns.join(',,').split(',');
  }

  // Interleaves the dataset with the values of the percentage indicators.
  // Example:
  // data:          [12, 10, 4, 3]
  // percentDiffs:  ['83%', '40%', '75%']
  // result:        [12, '83%', 10, '40%', 4, '75%', 3]
  datasetsWithPercentageIntervals() {
    let percentDiffs = this.props.data.percent_diff.map(percent => {
      return `${percent}%`;
    });
    let data =
      Array.isArray(this.props.data.datasets[0].data) ? this.props.data.datasets[0].data : [];

    return [
      {
        data: data
          .map((value, idx) => [value, percentDiffs[idx]])
          .flat()
          .filter(item => item !== undefined),
      },
    ];
  }

  // Interleaves the dataset with blank (zero) data to create unfilled bars in the chart
  datasetsWithSpacerIntervals() {
    let data = this.props.data.datasets[0].data
      .join(',0,')
      .split(',')
      .map(item => {
        return parseInt(item, 10);
      });
    let backgroundColor = this.props.data.datasets[0].backgroundColor
      .join(',"#000000",')
      .split(',');

    return [
      {
        data: data,
        backgroundColor: backgroundColor,
      },
    ];
  }

  // ChartJS is being tricked here to do something it normally doesn't.
  // We use two separate datasets, one for displaying the bars and one for displaying the labels
  // The bar dataset will use zeroes to create blank space between the "real" bars
  // The percentage dataset will use the percentage difference between the bars and only render the values above the bars
  //
  // The original dataset might look something like:
  //   [100, 80, 60, 40]
  // The bar dataset will be expanded to:
  //   [100, 0, 80, 0, 60, 0, 40]
  // The percentage dataset will be expanded to:
  //   [100, 80%, 80, 75%, 60, 66%, 40]
  render() {
    return (
      <BaseChart
        id="serviceRecoveryFunnel"
        type="bar"
        labels={this.labelsWithPercentageIntervals()}
        options={this.options(this.drawLabelsAboveBars, this.datasetsWithPercentageIntervals())}
        datasets={this.datasetsWithSpacerIntervals()}
      />
    );
  }
}

export default ServiceRecoveryFunnel;
/* eslint-enable no-undef */
/* eslint-enable react/no-deprecated */
